module.exports = __webpack_public_path__ + "img/9791155251072.c591be85.jpg";